import React from "react";

// Milk droplet inside income ring — brand mark
export const Logo = ({ size = 32, className = "", monotone = false }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width={size}
    height={size}
    className={className}
    aria-hidden="true"
  >
    <rect
      width="64"
      height="64"
      rx="14"
      fill={monotone ? "currentColor" : "#0F1F17"}
    />
    <path
      d="M32 12c6 8 12 15 12 22a12 12 0 1 1-24 0c0-7 6-14 12-22z"
      fill={monotone ? "var(--cream)" : "#FDFBF7"}
    />
    <circle
      cx="32"
      cy="38"
      r="4.5"
      fill={monotone ? "currentColor" : "#E65C00"}
    />
  </svg>
);

export const WordMark = ({ className = "" }) => (
  <div className={`flex items-center gap-2 ${className}`}>
    <Logo size={28} />
    <span
      className="font-display text-[1.15rem] font-medium tracking-tight"
      style={{ color: "var(--ink)" }}
    >
      Milk<span style={{ color: "var(--marigold)" }}>2</span>Income
    </span>
  </div>
);

export default Logo;
